import { createSlice } from "@reduxjs/toolkit";
import { fetchCurrentAssetBalance } from "./currentAssetBalanceThunk";

const initialState = {
  list: [],
  total_balance: 0,
  filters: {
    type: "All Current Asset Account",
    accId: null,
    fromDate: null,
    toDate: null,
  },
  loading: false,
};

const currentAssetBalanceSlice = createSlice({
  name: "currentAssetBalance",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentAssetBalance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCurrentAssetBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.list;
        state.total_balance = action.payload.total_balance;
      })
      .addCase(fetchCurrentAssetBalance.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = currentAssetBalanceSlice.actions;
export default currentAssetBalanceSlice.reducer;
